import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { inr, formatDate } from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import { Store, ShoppingBag, BadgeIndianRupee, TrendingUp } from "lucide-react";

export default function FranchiseDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/franchise/dashboard").then((r) => setD(r.data)); }, []);

  return (
    <DashboardLayout title="Franchise Dashboard" subtitle="POS sales · stock · commission" actions={
      <Link to="/franchise/pos" data-testid="open-pos" className="bg-gold text-navy px-4 py-2 text-sm rounded-sm font-medium inline-flex items-center gap-2"><Store size={14} /> Open POS</Link>
    }>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { l: "Orders Processed", v: d?.orders_count ?? 0, i: ShoppingBag, c: "border-navy" },
          { l: "Total Sales", v: inr(d?.total_sales ?? 0), i: BadgeIndianRupee, c: "border-gold" },
          { l: "Total SP", v: d?.total_sp ?? 0, i: TrendingUp, c: "border-olive" },
          { l: "Commission Wallet", v: inr(d?.wallets?.franchise ?? 0), i: BadgeIndianRupee, c: "border-rose" },
        ].map((s) => (
          <div key={s.l} className={`bg-white border-l-4 ${s.c} border-y border-r border-border p-5 rounded-r-sm`}>
            <div className="flex items-center justify-between">
              <div className="text-[10px] uppercase tracking-widest text-navy/50">{s.l}</div>
              <s.i size={14} className="text-navy/40" />
            </div>
            <div className="font-serif text-2xl text-navy mt-3">{s.v}</div>
          </div>
        ))}
      </div>
      <div className="mt-6 bg-white border border-border rounded-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-border"><h3 className="font-serif text-lg text-navy">Recent POS orders</h3></div>
        <table className="w-full text-sm">
          <thead className="bg-navy/5">
            <tr>{["Order #", "Items", "SP", "Total", "Date"].map((h) => <th key={h} className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium text-navy">{h}</th>)}</tr>
          </thead>
          <tbody>
            {(d?.recent_orders || []).map((o) => (
              <tr key={o.id} className="border-b border-border last:border-0">
                <td className="px-4 py-3 text-navy">{o.order_no}</td>
                <td className="px-4 py-3 text-navy/60">{o.items?.length || 0}</td>
                <td className="px-4 py-3 text-gold-deep">{o.total_sp}</td>
                <td className="px-4 py-3 font-semibold text-navy">{inr(o.total)}</td>
                <td className="px-4 py-3 text-xs text-navy/50">{formatDate(o.created_at)}</td>
              </tr>
            ))}
            {(d?.recent_orders || []).length === 0 && <tr><td colSpan={5} className="p-6 text-center text-navy/50">No POS sales yet</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
